(function () {
  var MOVE_MS = 650;
  var DRAG_THRESHOLD = 6;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function clamp(value, min, max) {
    if (value < min) return min;
    if (value > max) return max;
    return value;
  }

  function initSlider(root) {
    if (!root || root.dataset.sliderBound === 'true') return;

    var namesRoot = root.querySelector('[data-slider-names]');
    var track = root.querySelector('[data-slider-track]');
    if (!namesRoot || !track) return;

    var originalButtons = Array.prototype.slice.call(track.querySelectorAll('[data-slider-name]'));
    var count = originalButtons.length;
    if (count < 1) return;

    root.dataset.sliderBound = 'true';

    var images = root.querySelectorAll('[data-slider-image]');
    var panels = root.querySelectorAll('[data-slider-panel]');
    var headingEl = root.querySelector('[data-slider-heading]');
    var headingFallback = headingEl ? headingEl.getAttribute('data-heading-fallback') || '' : '';
    var counter = root.querySelector('[data-slider-counter]');
    var counterTemplate = counter ? counter.getAttribute('data-template') || '' : '';
    var imageMode = root.getAttribute('data-image-layout') === 'image';
    var media = root.querySelector('.full-screen-slider__media');
    var loop = count > 1;
    var ignoreSettle = false;
    var ignoreTimer = null;
    var dragging = false;
    var scrollIdle = null;
    var busy = false;
    var pending = null;
    var ticking = false;

    function updateCounter(real) {
      if (!counter || !counterTemplate) return;
      counter.textContent = counterTemplate
        .replace('__current__', String(real + 1))
        .replace('__total__', String(count));
    }

    if (loop) {
      var fragment = document.createDocumentFragment();
      for (var round = 0; round < 3; round++) {
        originalButtons.forEach(function (btn) {
          fragment.appendChild(btn.cloneNode(true));
        });
      }
      track.innerHTML = '';
      track.appendChild(fragment);
    }

    var buttons = Array.prototype.slice.call(track.querySelectorAll('[data-slider-name]'));
    var realIndex = -1;
    var visualIndex = -1;

    function namesOverflowing() {
      return namesRoot.scrollWidth > namesRoot.clientWidth + 1;
    }

    function nearestVisual() {
      var namesBox = namesRoot.getBoundingClientRect();
      var centerX = namesBox.left + namesBox.width / 2;
      var best = visualIndex;
      var bestDist = Infinity;
      buttons.forEach(function (btn, i) {
        var box = btn.getBoundingClientRect();
        var dist = Math.abs(box.left + box.width / 2 - centerX);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      });
      return best;
    }

    function visualProgress() {
      if (prefersReducedMotion()) return nearestVisual();

      var namesBox = namesRoot.getBoundingClientRect();
      var centerX = namesBox.left + namesBox.width / 2;
      var left = -1;
      var right = -1;
      var leftDist = -Infinity;
      var rightDist = Infinity;

      buttons.forEach(function (btn, i) {
        var box = btn.getBoundingClientRect();
        var mid = box.left + box.width / 2 - centerX;
        if (mid <= 0.5 && mid > leftDist) {
          leftDist = mid;
          left = i;
        }
        if (mid >= -0.5 && mid < rightDist) {
          rightDist = mid;
          right = i;
        }
      });

      if (left < 0) return right < 0 ? visualIndex : right;
      if (right < 0 || right === left) return left;
      var span = rightDist - leftDist;
      if (span <= 1) return left;
      return left + clamp(-leftDist / span, 0, 1);
    }

    function syncMedia() {
      if (images.length < 2) return;
      var p = visualProgress();
      var prev = Math.floor(p);
      var next = Math.ceil(p);
      if (prev < 0) prev = 0;
      if (next >= buttons.length) next = buttons.length - 1;
      var t = clamp(p - prev, 0, 1);
      var realPrev = Number(buttons[prev].getAttribute('data-index'));
      var realNext = Number(buttons[next].getAttribute('data-index'));

      images.forEach(function (img, i) {
        img.classList.remove('is-active', 'is-entering');
        if (i === realPrev && i === realNext) {
          img.classList.add('is-active');
          img.style.setProperty('--wipe', '1');
          img.style.setProperty('--shift', '0');
          return;
        }
        if (i === realNext && t > 0) {
          img.classList.add('is-entering');
          img.style.setProperty('--wipe', String(t));
          img.style.setProperty('--shift', String(1 - t));
          return;
        }
        if (i === realPrev) {
          img.classList.add('is-active');
          img.style.setProperty('--wipe', imageMode ? String(1 - t) : '1');
          img.style.setProperty('--shift', String(-t));
          return;
        }
        img.style.setProperty('--wipe', '0');
        img.style.setProperty('--shift', '0');
      });
    }

    function setChrome(real, visual) {
      if (real === realIndex && visual === visualIndex) return;
      realIndex = real;
      visualIndex = visual;

      buttons.forEach(function (btn, i) {
        var active = i === visual;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
        btn.tabIndex = active ? 0 : -1;
      });

      panels.forEach(function (panel, i) {
        var active = i === real;
        panel.classList.toggle('is-active', active);
        if (active) {
          panel.removeAttribute('inert');
          panel.removeAttribute('aria-hidden');
        } else {
          panel.setAttribute('inert', '');
          panel.setAttribute('aria-hidden', 'true');
        }
      });

      if (headingEl) {
        var headingPanel = panels[real];
        var headingText = headingPanel ? headingPanel.getAttribute('data-heading') || '' : '';
        headingEl.textContent = headingText || headingFallback;
      }

      updateCounter(real);
    }

    function applyFromScroll() {
      ticking = false;
      syncMedia();
      var visual = nearestVisual();
      setChrome(Number(buttons[visual].getAttribute('data-index')), visual);
    }

    function requestSync() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(applyFromScroll);
    }

    function center(instant) {
      var active = buttons[visualIndex];
      if (!active) return;
      var namesBox = namesRoot.getBoundingClientRect();
      var btnBox = active.getBoundingClientRect();
      var delta = btnBox.left + btnBox.width / 2 - (namesBox.left + namesBox.width / 2);
      if (Math.abs(delta) < 1) {
        requestSync();
        return false;
      }

      var reduce = prefersReducedMotion() || instant;
      window.clearTimeout(ignoreTimer);
      ignoreSettle = true;
      if (reduce) namesRoot.classList.add('is-instant');
      if (typeof namesRoot.scrollTo === 'function') {
        namesRoot.scrollTo({
          left: namesRoot.scrollLeft + delta,
          behavior: reduce ? 'auto' : 'smooth',
        });
      } else {
        namesRoot.scrollLeft += delta;
      }
      if (reduce) {
        void namesRoot.offsetWidth;
        namesRoot.classList.remove('is-instant');
        ignoreSettle = false;
        requestSync();
        return false;
      }
      ignoreTimer = window.setTimeout(finishProgrammatic, MOVE_MS + 50);
      requestSync();
      return true;
    }

    function settleSnap() {
      if (typeof namesRoot.scrollTo !== 'function') return;
      namesRoot.scrollTo({
        left: namesRoot.scrollLeft + 1,
        behavior: prefersReducedMotion() ? 'auto' : 'smooth',
      });
    }

    function reloopNow() {
      if (!loop) return;
      if (visualIndex >= count && visualIndex < count * 2) return;
      setChrome(realIndex, count + realIndex);
      center(true);
    }

    function finishProgrammatic() {
      window.clearTimeout(ignoreTimer);
      ignoreTimer = null;
      ignoreSettle = false;
      busy = false;
      applyFromScroll();
      reloopNow();
      if (!pending) return;
      var next = pending;
      pending = null;
      goTo(next.real, next.direction);
    }

    function onScrollSettle() {
      if (ignoreSettle || dragging) return;
      applyFromScroll();
      reloopNow();
    }

    function goTo(real, direction) {
      var nextReal = ((real % count) + count) % count;
      var nextVisual;

      if (loop) {
        if (direction > 0) {
          nextVisual = visualIndex + 1;
          while (nextVisual < buttons.length && Number(buttons[nextVisual].getAttribute('data-index')) !== nextReal) {
            nextVisual += 1;
          }
        } else if (direction < 0) {
          nextVisual = visualIndex - 1;
          while (nextVisual >= 0 && Number(buttons[nextVisual].getAttribute('data-index')) !== nextReal) {
            nextVisual -= 1;
          }
        } else {
          nextVisual = count + nextReal;
        }
        if (nextVisual < 0 || nextVisual >= buttons.length) {
          nextVisual = count + nextReal;
        }
      } else {
        nextVisual = nextReal;
      }

      realIndex = nextReal;
      visualIndex = nextVisual;
      if (center(false)) busy = true;
    }

    function queueOrGo(real, direction, step) {
      if (busy) {
        if (step) {
          pending = { real: realIndex + direction, direction: direction };
        } else {
          pending = { real: real, direction: direction };
        }
        return;
      }
      goTo(real, direction);
    }

    function bindDrag(surface, mouseOnly) {
      var pointerId = null;
      var startX = 0;
      var startY = 0;
      var startScroll = 0;
      var moved = false;
      var axis = null;
      var suppressClick = false;

      surface.addEventListener('pointerdown', function (event) {
        if (mouseOnly && event.pointerType !== 'mouse') return;
        if (event.button !== 0) return;
        if (!namesOverflowing()) return;
        if (event.target.closest && event.target.closest('a')) return;

        pointerId = event.pointerId;
        startX = event.clientX;
        startY = event.clientY;
        startScroll = namesRoot.scrollLeft;
        moved = false;
        axis = mouseOnly ? 'x' : null;
      });

      surface.addEventListener('pointermove', function (event) {
        if (pointerId === null || event.pointerId !== pointerId) return;

        var dx = event.clientX - startX;
        var dy = event.clientY - startY;

        if (!moved) {
          if (Math.abs(dx) < DRAG_THRESHOLD && Math.abs(dy) < DRAG_THRESHOLD) return;
          if (!mouseOnly && axis === null) {
            axis = Math.abs(dx) >= Math.abs(dy) ? 'x' : 'y';
          }
          if (axis !== 'x') return;
          moved = true;
          dragging = true;
          namesRoot.classList.add('is-dragging');
          if (typeof surface.setPointerCapture === 'function') {
            surface.setPointerCapture(event.pointerId);
          }
        }

        if (axis !== 'x') return;
        event.preventDefault();
        namesRoot.scrollLeft = startScroll - dx;
      });

      function endDrag(event) {
        if (pointerId === null || event.pointerId !== pointerId) return;
        if (typeof surface.releasePointerCapture === 'function' && surface.hasPointerCapture(pointerId)) {
          surface.releasePointerCapture(pointerId);
        }
        pointerId = null;
        axis = null;
        var wasMoved = moved;
        moved = false;
        dragging = false;
        namesRoot.classList.remove('is-dragging');
        if (wasMoved) {
          suppressClick = true;
          window.setTimeout(function () {
            suppressClick = false;
          }, 0);
          settleSnap();
        }
      }

      surface.addEventListener('pointerup', endDrag);
      surface.addEventListener('pointercancel', endDrag);

      if (mouseOnly) {
        surface.addEventListener(
          'click',
          function (event) {
            if (!suppressClick) return;
            event.preventDefault();
            event.stopPropagation();
          },
          true
        );
        surface.addEventListener('dragstart', function (event) {
          event.preventDefault();
        });
      }
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var real = Number(btn.getAttribute('data-index'));
        var visual = buttons.indexOf(btn);
        if (real === realIndex && visual === visualIndex) return;
        queueOrGo(real, visual > visualIndex ? 1 : -1, false);
      });
    });

    namesRoot.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
      event.preventDefault();
      if (event.key === 'ArrowRight') queueOrGo(realIndex + 1, 1, true);
      else queueOrGo(realIndex - 1, -1, true);
      if (buttons[visualIndex]) buttons[visualIndex].focus();
    });

    namesRoot.addEventListener(
      'scroll',
      function () {
        requestSync();
        if (ignoreSettle || dragging) return;
        window.clearTimeout(scrollIdle);
        scrollIdle = window.setTimeout(onScrollSettle, 80);
      },
      { passive: true }
    );

    namesRoot.addEventListener('scrollend', function () {
      window.clearTimeout(scrollIdle);
      if (dragging) return;
      if (ignoreSettle) {
        finishProgrammatic();
        return;
      }
      onScrollSettle();
    });

    bindDrag(namesRoot, true);
    if (media) bindDrag(media, false);

    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        center(true);
      }, 100);
    });

    root._fullScreenSliderRecenter = function () {
      center(true);
    };

    setChrome(0, loop ? count : 0);
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(function () {
        center(true);
      });
    } else {
      center(true);
    }
  }

  function isSliderVisible(root) {
    var section = root.closest('.shopify-section');
    if (section && (section.hidden || section.classList.contains('showcase-is-hidden'))) return false;
    if (root.hidden) return false;
    var names = root.querySelector('[data-slider-names]');
    return Boolean(names && names.offsetWidth > 0);
  }

  function recenterVisible() {
    document.querySelectorAll('[data-full-screen-slider]').forEach(function (root) {
      if (typeof root._fullScreenSliderRecenter !== 'function') return;
      if (!isSliderVisible(root)) return;
      root._fullScreenSliderRecenter();
    });
  }

  function initAll(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-full-screen-slider]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) initAll(event.target);
  });

  /* Showcase hides inactive modules before this script runs; recenter when one becomes visible. */
  document.addEventListener('joselito:showcase-module', function () {
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(recenterVisible);
    });
  });
})();
